require('./selectProject')
require('./selectHouse')
require('./personalData')
require('./adminPersonalData')
require('./signaturePad')
require('./bankData')
require('./customerSubscription')
require('./addFamilyGroup')
require('./SignDocument/signingDocument')
require('./SignDocument/onlineDocument')
